// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-71393584] .el-checkbox-group {\n  display: flex !important;\n  flex-wrap: wrap !important;\n}\n[data-v-71393584] .el-checkbox {\n  width: 50% !important;\n  margin-right: 0 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
